var map = {
	"./Efe Odiete Osanyinjobi.jpeg": 8685,
	"./Elizabeth Onaodowan.jpeg": 2446,
	"./Kelvin Oteri.jpeg": 3238,
	"./Rukevwe Ojameruaye.jpeg": 6727,
	"./Veronica Gbago.jpeg": 325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2743;